import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import FilterPanelWidget from '../../moreCore/UI/FilterPanel/FilterPanel';
import "../../moreCore/UI/FilterPanel/FilterPanel";
import template from './_templateV2.html?raw';

import "../FinderBase/FinderBaseTypes";
import FilterPanelOption from '../../moreCore/UI/FilterPanel/FilterPanelOption';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import { isArray } from "dojo/_base/lang";
import { _TabEnabledMixin } from "../../moreCore/_loadingHelpers/Tabbing";
import "../../moreCore/UI/Toaster_TS/Toaster";

import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes } from "../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { FinderTypes } from "../FinderBase/FinderBaseTypes";
import { TranslationHelpers } from "../../more/Helpers";
import Button from '../../moreCore/UI/Button/Button';



interface FinderBaseLocalSettings {
    internalName: string,
    userId: string,
    lastSetLayoutname: string
}
class FinderBaseV2 extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    // must-have attach-points in the template------------------------------ start
    private filterPanelContainer: HTMLDivElement;
    private sectionResult: HTMLDivElement;
    private resultMessageErrorContainer: HTMLElement;
    private resultMessageError: HTMLElement;
    private resultContainer: HTMLElement;
    private btnSubmitLabel: HTMLElement;
    private btnSubmit: HTMLElement;
    private btnNew: HTMLElement;
    private topContainer: HTMLElement;
    protected tableContainer: HTMLElement;
    private reloadContainer: HTMLElement;
    private buttonGroupContainer: HTMLElement;
    private mainButtonsContainer: HTMLElement;

    // must-have attach-points in the template ------------------------------ end

    // diverses Paging-Properties; attach-points werden verwendet falls im Template vorhanden
    private btnReloadPage: HTMLButtonElement;
    private btnNextPage: HTMLButtonElement;
    private btnPreviousPage: HTMLButtonElement;
    private btnFirstPage: HTMLButtonElement;
    private btnLastPage: HTMLButtonElement;
    private pagingContainer: HTMLElement;
    private bottomPagingSection: HTMLElement;
    private resultInfoContainer: HTMLElement;
    private pagingClassesEnabled: string; // default
    private pagingClassesDisabled: string; // default
    private pagingInfoFormatstring: string = "{2} - {3} / {0}";
    //private classesEnabled: string = ""; // default
    //private classesDisabled: string = "w3-disabled"; // default

    // ---------------------

    private _currentFilterSettings: string = "";
    private _currentFilterSettingsApplied: string = "";
    protected isDirty: boolean = false;
    protected _isRequestActive: boolean = false;

    private isPagingEnabled: boolean = false;
    protected _currentPage: number = -1;

    //protected _nextStartIndex: number = 0;
    //protected _currentStartIndex: number = 0;

    private setupConfig: FinderTypes.FinderSetupConfig = null;
    private _finderOptions: FinderTypes.FinderOptions;
    protected lastResponse: more.PackedEntitylistResult<any> = null;/*{
        totalResultCount: 0,
        entitylist: [],
        currentLimit: this._maxResultCount
    };*/

    protected _completeList: Array<any> = [];

    //filterpanels: Array<FilterPanel>;
    protected filterpanel: MdsLax<InstanceType<typeof FilterPanelWidget>>;
    protected table: MdsLax<InstanceType<typeof StaticTable>>;

    private onFilterListResponse: Function;
    protected _maxResultCount: number = -1;
    protected _tableLayouts: Array<StaticTable.Layout>;


    private _timeoutHandle: number = null;



    internalName: string = null; // fürs Merken von Tabellenlayouts



    private btnSubmitLabelText: string; // to be replaced with translation in a childclass

    protected disableConfigStorage: boolean = false;

    //// ----------------------------- Methods ------------------------------------------

    private loadFinderConfig(): void {

        if (!this.setupConfig.configUrl && !this.setupConfig.configCallfunction) {
            alert("No URL and Callfunction for filteroptions specified!");
            return;
        }

        // mit dem Bypass lädt das Filterpanel ZACK sofort aus dem Localstorage -
        // das Laden passiert trotzdem im Hintergrund, ist halt dann um 1 Zyklus verzögert
        // sollte in der Praxis wurscht sein
        let bypassSuccessful: boolean = false;

        if (this.disableConfigStorage != true) {
            let storedData = localStorage.getItem(location.pathname + "_" + this.id + "_filterOptions_");

            if (storedData) {
                try {

                    this.bypassFilteroptionsLoading(JSON.parse(storedData));
                    bypassSuccessful = true;
                }
                catch (ex) {
                    console.warn("stored data for filteroptions invalid", storedData, this.id);
                }
            }
        }
        if (!bypassSuccessful) {
            this.hourGlassStart();
        }

        if (this.setupConfig.configCallfunction) {
            this.RequestManager.callfunction(
                this.setupConfig.configCallfunction,
                this._createRequestData().jsonData,
                lang.hitch(this, this._onLoadFinderConfigResponse, bypassSuccessful),
                lang.hitch(this, this._onLoadFinderConfigError)
            );

        } else {

            let url = window.appRoot + this.setupConfig.configUrl;

            let jsonData = null;

            this.RequestManager.post(
                url,
                this._createRequestData(),
                lang.hitch(this, this._onLoadFinderConfigResponse, bypassSuccessful),
                lang.hitch(this, this._onLoadFinderConfigError),
                false // sync
            );
        }
    }

    private _createRequestData(baseData?: Object): { jsonData: string } {


        if (this.requestData != null) {
            if (!baseData) {
                baseData = {};
            }
            baseData = { ...this.requestData, ...baseData };
        }

        let requestData = {
            jsonData: baseData ? JSON.stringify(baseData) : null
        };
        if (this.requestParams.length) {
            for (let param of this.requestParams) {
                requestData[param.name] = JSON.stringify(param.value);
            }
        }

        return requestData;
    }

    private bypassFilteroptionsLoading(data: FinderTypes.FinderOptions) {
        this.applyFinderConfig(data);
    }

    private _onLoadFinderConfigResponse(isBypassed: boolean, response: FinderTypes.FinderOptions) {

        //console.log("_onLoadFilterOptions Response: ", response)
        localStorage.setItem(location.pathname + "_" + this.id + "_filterOptions", JSON.stringify(response));
        if (isBypassed) {

        } else {

            this.hourGlassEnd();

            this.applyFinderConfig(response);
        }
    }

    private _onLoadFinderConfigError(error: any) {

        this.hourGlassEnd();

        alert(this.translate("Error__OptionsCantBeLoaded") + error.Message);
        console.log(this.translate("Error__OptionsCantBeLoaded") + error.Message);
    }

    private setMaxResultCount(count: number) {
        this._maxResultCount = count;
        this._checkPagingEnabled();
    }

    private _checkPagingEnabled() {
        if (this._maxResultCount > 0) {
            this.isPagingEnabled = true;
        } else {
            this.isPagingEnabled = false;
        }
    }

    private applyFinderConfig(resultOptions: FinderTypes.FinderOptions) {

        this._finderOptions = resultOptions;

        // this.filterPanelContainer_nodeName muss in der Childclass gesetzt werden !
        if (this.filterPanelContainer) {
            this.UiModder.domConstruct.empty(this.filterPanelContainer);
        } else {
            alert(this.id + ": no filterPanelContainer defined");
            return;
        }

        if (typeof (resultOptions.limit) != "undefined") {
            this.setMaxResultCount(resultOptions.limit);
        }

        if (resultOptions.tableLayouts) {

            //console.debug("finderbase: set table layouts", this._layouts);
            if (isArray(resultOptions.tableLayouts)){
                this._tableLayouts = resultOptions.tableLayouts;
            }
            else {
                this._tableLayouts = [];
                this._tableLayouts.push(resultOptions.tableLayouts);
            }
        }

        this.UiModder.domConstruct.empty(this.filterPanelContainer);

        if (resultOptions.sections) {
            let fp = new FilterPanelWidget();
            this.filterpanel = fp;
            on(fp, "submitClick", lang.hitch(this, this._onClick_Submit));

            fp.placeAt(this.filterPanelContainer);
            fp.outputFormat = FilterPanelFormat.compact; // das Format lassen wir jetzt mal fix. data.format == "compact" ? "compact" : "default";

            //fp.setSectionData(data.sections);
            fp.setConfig(resultOptions);

            on(this.filterpanel, "serializedData", lang.hitch(this, this.checkDirtyState_delayed));
            //on(this.filterpanel, "valueChange", lang.hitch(this, function (dataObj: FilterPanel.ValueChangeNotice) {
            //    this.checkDirtyState_delayed();
            //    this._onOptionValueChange(dataObj);
            //})); // _onOptionValueChange gibts nicht mehr!

            this.filterpanel.serializeData();

            this.hideNode(this.topContainer, false);


        } else {
            this.filterpanel = null;
            if (this.filterPanelContainer) {
                this.UiModder.domClass.add(this.filterPanelContainer, "w3-hide");
            }
            this.UiModder.domClass.add(this.btnSubmit, "w3-hide");

            this.checkDirtyState();
        }

        setTimeout(lang.hitch(this, function () { this._initialLoadDone = true; }), 1200);
    }

    private _getLayoutByName(name: string): StaticTable.Layout {
        //console.log("this._layouts: ", this._layouts);
        if (this._tableLayouts) {

            if (Array.isArray(this._tableLayouts)) { // das wird bei der BST der Fall sein
                for (var layout of this._tableLayouts) {
                    if (layout.name == name) {
                        return layout;
                    }
                }
            } else {
                console.log("this._layouts is NOT an array, most likely you are using the wrong Layouts Configuration Structure for BST.");
            }
        }

        return null;
    }

    private checkDirtyState_delayed(result: boolean): void {

        // bestehendes Event unterbrechen
        if (this._timeoutHandle != null) {
            clearTimeout(this._timeoutHandle);
            this._timeoutHandle = null;
        }

        this._timeoutHandle = setTimeout(lang.hitch(this, this.checkDirtyState, result), 100);
    }

    private _autosubmitHandle: any = null;
    private checkDirtyState(/*bForceState?: boolean*/): void {

        //console.debug("checkDirtyState");

        //if (bForceState === true || bForceState === false) {
        //    this.setDirty(bForceState);
        //    return;
        //}

        if (this._autosubmitHandle) clearTimeout(this._autosubmitHandle);

        if (this.filterpanel) {
            let json = { sections: this.filterpanel.getData() };//, currentStartIndex: this._currentStartIndex, limit: this._maxResultCount };
            var bValid = json.sections !== null;

            let jsonString = JSON.stringify(json)
            this._currentFilterSettings = jsonString;
            this.setDirty(this._currentFilterSettingsApplied != this._currentFilterSettings && bValid === true);

            if (this.filterpanel.getFilterOptions(true).length == 1 && bValid === true && this.isDirty === true) {
                this._autosubmitHandle = setTimeout(lang.hitch(this, this._onClick_Submit), 20);
            }

        } else {
            this.setDirty(true);
        }

    }

    reload(): void {
        this.reloadData();
    }

    reloadData(): void {
        this.isDirty = true;
        this.getFilterlist(this._currentPage);
    }

    //protected setCreateNewCallback(callback: Function) {
    //    if (typeof (callback) == "function") {
    //        this._displayNewButton(true, callback)
    //    } else {

    //    }
    //}

    private _displayNewButton(callback, bShow: boolean): void {

        let isCallbackValid = typeof (callback) == "function";

        if (this.isEmbeddedInTab) {
            if (isCallbackValid && bShow) {

                this.createDefaultButton("new", callback);
            }
            else {
                this.requestContextButtonRemove("new");
            }
        }

        if (this.btnNew) {
            this.UiModder.domClass.toggle(this.btnNew, "w3-hide", !bShow);
            this._setCyAttribute(this.btnNew.getAttribute("data-dojo-attach-point"), this.btnNew);
            this.btnNew.setAttribute("data-e2e-role", "button");


            //this.UiModder.domClass.toggle(this.btnNew, this.classesDisabled, !isCallbackValid);
            //this.UiModder.domClass.toggle(this.btnNew, this.classesEnabled, isCallbackValid);
            this.disableNode(this.btnNew, !isCallbackValid);

            if (isCallbackValid) {
                on(this.btnNew, "click", callback);
            }
        }
    }

    protected addButtonMainContainer(config: { label: string, icon: string, name: string, type?: "primary" | "secondary" | "tertiary" | "basic", styleClass?: string, callback: (evt) => void }): void {
        //let button = this.UiModder.domConstruct.create("button", { class: `mds-button-base round w3-padding w3-large hoverBright ${config.color}`, id: config.name }, this.mainButtonsContainer, "last");
        let actualStyleclass = "submitBtn";

        if (config.styleClass) {
            actualStyleclass = config.styleClass;
        } else {

            switch (config.type) {
                case "primary":
                    actualStyleclass = "submitBtn";
                    break;

                case "secondary":
                case "basic":
                    actualStyleclass = "secondaryBtn submitBtn";
                    break;

                case "tertiary":
                    actualStyleclass = "submitBtn tertiaryBtn";
                    break;


            }
        }

        let button = new Button();
        button.setup({
            callback: config.callback,
            iconClass: config.icon,
            label: config.label,
            styleClass: actualStyleclass,
            parentNode: this.mainButtonsContainer
        });
        button.setCyName("ButtonMainContainer:" + config.name);

        if (!this._customMainButtons) this._customMainButtons = {};
        this._customMainButtons[config.name] = {
            node: button.domNode,
            widget: button
        };
    }
    private _customMainButtons: Record<string, { node: HTMLElement, widget: MdsLax<InstanceType<typeof Button>> }>;
    protected removeButtonMainContainer(name: string): void {
        
        let button = document.getElementById(name);
        if (button) this.UiModder.domConstruct.destroy(button);

        if (this._customMainButtons) {
            let reg = this._customMainButtons[name];
            if (reg) {
                if (reg.node) {
                    this.UiModder.domConstruct.destroy(button);
                }

                this._customMainButtons[name] = null;
            }
        }
        
    }

    private _retryGetFilterlist: boolean = true;
    getFilterlist(pageNo?: number): void {

        if (!this.setupConfig.filterdataUrl && !this.setupConfig.filterdataCallfunction) {
            alert(this.id + ": No URL and Callfunction for getFilterList specified!")
            return;
        }

        if (pageNo) {
            this.setPage(pageNo, true);
            return;
        }

        if (this.isDirty) {
            this._completeList = [];
        }

        this.UiModder.domClass.remove(this.sectionResult, "w3-hide");


        let url = window.appRoot + this.setupConfig.filterdataUrl;
        this._isRequestActive = true;
        this.setPagingStyle();

        let data = null;

        if (this.filterpanel) {
            try {
                data = JSON.parse(this._currentFilterSettings);
            } catch (ex) {
                console.warn(this.id + ": invalid filtersettings? cannot parse json, probably race condition.", ex);
                if (this._retryGetFilterlist) {
                    setTimeout(lang.hitch(this, this.getFilterlist, pageNo), 600);
                    this._retryGetFilterlist = false;
                }
                return;
            }

            this._retryGetFilterlist = true;
        } else {
            data = {};
        }
        if (data && this.isPagingEnabled) {
            data.limit = this._maxResultCount;
            data.currentStartIndex = this._getOffsetFromPage(this._currentPage);
        }

        this.hideNode(this.sectionResult, false);

        this.StandbyStart(this.sectionResult);

        data = this._createRequestData(data);

        if (this.setupConfig.filterdataCallfunction) {
            this.RequestManager.callfunction(
                this.setupConfig.filterdataCallfunction,
                data.jsonData,
                lang.hitch(this, this._onGetFilterlistResult, this._currentFilterSettings),
                lang.hitch(this, this._onGetFilterlistError, this._currentFilterSettings),
            );
        } else {

            //console.log("GET FILTERLIST DATA::: STR ", stringData)
            //console.log("GET FILTERLIST DATA::: ", data)

            this.RequestManager.post(
                url,
                data,
                lang.hitch(this, this._onGetFilterlistResult, this._currentFilterSettings),
                lang.hitch(this, this._onGetFilterlistError, this._currentFilterSettings),
                false // sync
            );
        }
    }

    private _onGetFilterlistResult(currentFiltersettings: string, response: more.PackedEntitylistResult<any>) {

        this.StandbyStop();
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = currentFiltersettings;
        // wenn filterpanel: nochmal prüfen ob synchron. user könnte während Ladezeit was geändert haben.
        if (this.filterpanel) {
            this.checkDirtyState();
        } else {
            this.setDirty(false);
        }

        this.lastResponse = response;

        this.showError(false);

        this.processFilterListResponse(response);

        this.setPagingStyle();
    }

    private _onGetFilterlistError(currentFilterSettings:string ,error: any ): void {

        this.lastResponse = null;

        console.error(error);
        this.StandbyStop();
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = currentFilterSettings;

        if (error.Message) {
            alert(error.Message);
        }

        this.showError(error.Message);
        //alert(error.message);
    }

    //private selectedPageButton = null;
    private setPagingStyle(): void {

        //console.log("setPagingStyle", this.lastResponse, this.isDirty, this._currentPage);

        let pagesTotal = this._getMaxPagesFromResult();
        let currentPage = this._currentPage;
        let resultIndexThisPage = this._getMinIndexOfPage(currentPage) + 1;
        let resultIndexMaxThisPage = this._getMaxIndexOfPage(currentPage) + 1;
        if (this.isPagingEnabled) {
            if (TranslationHelpers.canTranslate("StaticTable_ResultInfo")) {
                this.pagingInfoFormatstring = TranslationHelpers.translate("StaticTable_ResultInfo");
            }

            let shownPages: Array<number> = [];

            if (this.pagingContainer) {
                // wenns zu viele gibt: begrenzen auf Start, Ende und ein paar rund um die aktuelle Seite herum
                if (pagesTotal > 15) {
                    shownPages.push(1);
                    shownPages.push(2);
                    shownPages.push(3);

                    for (let x = this._currentPage - 3; x < this._currentPage + 4; x++) {
                        shownPages.push(x);
                    }

                    shownPages.push(pagesTotal - 2);
                    shownPages.push(pagesTotal - 1);
                    shownPages.push(pagesTotal - 0);
                }

                if (this.lastResponse && !this._isRequestActive) {
                    let indexPerPage = 0;

                    let container = this.UiModder.domConstruct.create("div", {
                        id: "pagingButtonsContainerTop",
                        class:"buttonGroup"
                    });
                    let secondContainer = null;

                    if (this.bottomPagingSection) {
                        secondContainer = container.cloneNode(true);
                        secondContainer.id = "pagingButtonsContainerBottom";

                        this.UiModder.domConstruct.place(secondContainer, this.bottomPagingSection);
                    }

                    let insertSpacer: boolean = true;

                    for (let pageNo = 1; pageNo <= pagesTotal; pageNo++) {

                        if (shownPages.indexOf(pageNo, 0) != -1 || shownPages.length == 0) {
                            insertSpacer = true;

                            // button zeichnen:
                            let button = this.UiModder.domConstruct.create("button", {
                                "className": "mds-button-base pagingButton",
                                "innerHTML": pageNo.toString(),
                                "id": "pageBtn-" + pageNo.toString()
                            }, container);


                            if (pageNo == this._currentPage) {
                                this.UiModder.domClass.add(button, "selected");

                            } else {
                                this.UiModder.domClass.add(button, "hoverBright");
                                on(button, "click", lang.hitch(this, this.setPage, pageNo, true));
                            }

                            if (secondContainer) {
                                let bottomButton: HTMLButtonElement = <HTMLButtonElement>button.cloneNode(true);
                                this.UiModder.domConstruct.place(bottomButton, secondContainer);

                                this.UiModder.domAttr.set(bottomButton, "id", "pageBtnSecond-" + pageNo.toString());

                                if (pageNo == this._currentPage) {
                                } else {
                                    on(bottomButton, "click", lang.hitch(this, this.setPage, pageNo, true));
                                }
                            }

                        } else {
                            if (insertSpacer) {
                                insertSpacer = false;

                                let spacer = this.UiModder.domConstruct.create("span", {
                                    "className": "spacer",
                                    "innerHTML": " • • • "
                                }, container);


                                if (secondContainer) {
                                    let bottomSpacer = spacer.cloneNode(true);
                                    this.UiModder.domConstruct.place(bottomSpacer, secondContainer);
                                }
                            }
                        }
                    }

                    //this.UiModder.domConstruct.empty(this.pagingContainer);
                    this.UiModder.domConstruct.place(container, this.pagingContainer, "only");
                    this.UiModder.domClass.remove(this.pagingContainer, "w3-disabled");
                    this.hideNode(this.pagingContainer, !(pagesTotal > 1));

                    if (secondContainer) {
                        this.UiModder.domConstruct.place(secondContainer, this.bottomPagingSection, "only");
                        this.UiModder.domClass.remove(this.bottomPagingSection, "w3-disabled");
                        this.hideNode(this.bottomPagingSection, !(pagesTotal > 1));

                    }
                }
                else if (this._isRequestActive) {
                    this.UiModder.domClass.add(this.pagingContainer, "w3-disabled");
                    if (this.bottomPagingSection) {
                        this.UiModder.domClass.add(this.bottomPagingSection, "w3-disabled");
                    }
                }
                else {
                    this.UiModder.domConstruct.empty(this.pagingContainer);
                    this.UiModder.domClass.add(this.pagingContainer, "w3-hide");

                    if (this.bottomPagingSection) {
                        this.UiModder.domConstruct.empty(this.bottomPagingSection);
                        this.hideNode(this.bottomPagingSection);
                    }
                }

            }



            //if (this.btnContinue) {
            //    if ((endOfList != true || this.getDirty() == true) && this._isRequestActive != true) {
            //        this.UiModder.domClass.remove(this.btnContinue, this.classesDisabled);
            //        this.UiModder.domClass.add(this.btnContinue, this.classesEnabled);
            //    } else {
            //        this.UiModder.domClass.remove(this.btnContinue, this.classesEnabled);
            //        this.UiModder.domClass.add(this.btnContinue, this.classesDisabled);
            //    }
            //}

        } else {
            this._currentPage = 1;

            if (this.pagingContainer) this.hideNode(this.pagingContainer);

            if (TranslationHelpers.canTranslate("StaticTable_ResultCount")) {
                this.pagingInfoFormatstring = TranslationHelpers.translate("StaticTable_ResultCount");
            }

            if (this.bottomPagingSection) {
                this.hideNode(this.bottomPagingSection);
            }
        }

        if (this.resultInfoContainer) {
            /*
                0 - Gesamtzähler Ergebnisse
                1 - Anzahl gezeigte Ergebnisse
                2 - Gezeigte Ergebnisse ab X
                3 - Gezeigte Ergebnisse bis Y
                4 - Aktuelle "Seite"
                5 - Anzahl "Seiten"

                */
            if (this.lastResponse && !this._isRequestActive) {
                if (this.lastResponse.totalResultCount == 0) {
                    this.resultInfoContainer.innerHTML = this.translate("General__NoEntries");
                    //    this.stringFormat(this.pagingInfoFormatstring,
                    //    this.lastResponse.totalResultCount.toString(),
                    //    "0",
                    //    "0",
                    //    "0",
                    //    "1",
                    //    "1"
                    //);
                } else {

                    this.resultInfoContainer.innerHTML = this.stringFormat(this.pagingInfoFormatstring,
                        this.lastResponse.totalResultCount ? this.lastResponse.totalResultCount.toString() : this._completeList.length.toString(),
                        this._maxResultCount.toString(),
                        resultIndexThisPage.toString(),
                        resultIndexMaxThisPage.toString(),
                        this._currentPage.toString(),
                        pagesTotal.toString()
                    );
                }

                this.UiModder.domClass.remove(this.resultInfoContainer, "w3-disabled w3-hide");
            } else if (this._isRequestActive) {
                this.UiModder.domClass.add(this.resultInfoContainer, "w3-disabled");
            }

        }

        this.setSubmitButtonStyles();

    }

    protected getFilterOptionByName(optionName: string): MdsLax<InstanceType<typeof FilterPanelOption>> {
        if (this.filterpanel) {
            return this.filterpanel.getFilterOptionByName(optionName);
        }

        return null;
    }

    protected showError(message: string | false, bKeepResultVisible?: boolean) { // sollte in die viewBase... ist aber gut abgesichert, kann nix passieren
        if (message === false) {
            if (this.resultMessageErrorContainer) this.UiModder.domClass.add(this.resultMessageErrorContainer, "w3-hide");
        } else {
            if (this.resultMessageError) this.UiModder.domAttr.set(this.resultMessageError, "innerHTML", message);
            if (this.resultMessageErrorContainer) this.UiModder.domClass.remove(this.resultMessageErrorContainer, "w3-hide");

            if (bKeepResultVisible !== true) {
                if (this.resultContainer) this.UiModder.domClass.add(this.resultContainer, "w3-hide");
            }
        }
    }

    private _loadLocaleSettings(): Array<FinderBaseLocalSettings> {
        let result = [];
        let userId = this.getCurrentUserId();
        if (!this.hasFeature("System/SaveLocalLayoutSettings")) return result;
        if (!userId) return result;


        try {
            let str = localStorage.getItem("ego_FinderSettings");

            if (str) {
                let storedSettings: Array<FinderBaseLocalSettings> = JSON.parse(str);

                return storedSettings;
            }

        } catch (ex) {
            return [];
        }

        return result;
    }

    private _getLocalTableSetting(): FinderBaseLocalSettings {
        if (!this.internalName) return null;

        let localSettings = this._loadLocaleSettings();
        let userId = this.getCurrentUserId();

        for (let setting of localSettings) {
            if (setting.internalName == this.internalName && setting.userId == userId) {
                return setting;
            }
        }

        return null;
    }

    private _saveLocalTableSetting(data: FinderBaseLocalSettings) {
        if (!this.internalName) return;
        if (!this.hasFeature("System/SaveLocalLayoutSettings")) return;
        if (!data) return;

        let localSettings = this._loadLocaleSettings();

        for (let i = 0; i < localSettings.length; i++) {
            let setting = localSettings[i];
            if (setting.internalName == this.internalName && setting.userId == data.userId) {
                localSettings.splice(i, 1);
            }
        }

        localSettings.push(data);

        localStorage.setItem("ego_FinderSettings", JSON.stringify(localSettings));
    }

    private _onTableLayoutChanged(newLayout: StaticTable.Layout) {
        if (newLayout) {
            this._saveLocalTableSetting({
                internalName: this.internalName,
                lastSetLayoutname: newLayout.name,
                userId: this.getCurrentUserId()
            });
        }
    }



    // handle the Data here
    private createTable(response?: more.PackedEntitylistResult<any>): MdsLax<InstanceType<typeof StaticTable>> {

        let table: MdsLax<InstanceType<typeof StaticTable>>;
        let layout: StaticTable.Layout;
        let tableId: string = null;

        if (this.lastResponse.layouts) {
            for (let layout of this.lastResponse.layouts) {
                this._tableLayouts.push(layout);
            }
        }

        table = this.table;
        let previousLayout: StaticTable.Layout = null;
        if (table) {
            previousLayout = table.getSelectedLayout();
            table.destroy();
            this.table = null;
            table = null;
        }

        if (!table) {

            if (!this.resultContainer) {
                alert(this.id + ": cannot create table - resultContainer missing");
                console.log(this.id + ": cannot create table - resultContainer missing");
                return;
            }

            //alte Tabelle weg
            //console.debug("alte Table destroy?", table, tableParams);
            if (table != null) table.destroy();
            this.resultContainer.innerHTML = null;

            this.showError(false);
            table = new StaticTable(); // default

            this.emit("tableCreated", table);
            this._onTableCreated(table);

            //für Test Dom Event werfen - damit Test weiß, wann die table fertig zum Auslesen ist
            //eigener e2e-Name, damit es nicht mit dem Widget-Event this.emit("tableCreated") kollidiert
            const containerEl = this.domNode;
            if (containerEl) {
                containerEl.dispatchEvent(
                    new CustomEvent("e2eTableNodeCreated", {
                        detail: {
                            table,
                            tableElement: table?.domNode ?? null,
                        },
                        bubbles: true,
                    })
                );
            }
 
            tableId = table.id;

            if (this.setupConfig.showIndexColum) {
                table.showIndexColumn = true;
            }

            table.labelProperty = this.setupConfig.labelProperty;

            for (let layout of this._tableLayouts) {
                table.addLayout(layout);
            }


            let button = table.getLayoutSelectorButton();
            if (button) {
               button.placeAt(this.buttonGroupContainer, "first");
               button.setCyName("Button:" + this.internalName + ":LayoutSelector");
            }

            if (this.setupConfig.tableRowExpanderConfig) {
                table.setupExpandableRows({
                    expanderContentCallback: this.setupConfig.tableRowExpanderConfig.contentSetupCallback,
                    expanderClickCallback: this.setupConfig.tableRowExpanderConfig.expandClickCallback
                });
            }

            table.setFormatter(this.setupConfig.tableFormatterFunction);
            table.setRowClick(this.setupConfig.rowClickFunction);


            // Layouts: Variante 1 - vorheriges wiederherstellen. wichtig beim Blättern!
            let bTryNextLayout = true;
            if (previousLayout) {
                if (table.setLayoutByName(previousLayout.name) == true) {
                    bTryNextLayout = false;
                }
            }

            // kein vorheriges Layout oder hat nicht funktioniert? zuletzt lokal eingestelltes Layout abrufen:
            if (bTryNextLayout) {
                let preset = this._getLocalTableSetting();
                if (preset) {
                    if (table.setLayoutByName(preset.lastSetLayoutname) == true) {
                        bTryNextLayout = false;
                    }
                }
            }

            // Flag steht immer noch auf true? dann preset aus den Finderoptions versuchen
            if (bTryNextLayout) {
                if( this._finderOptions.presetTableLayout) {
                    //console.debug("FinderViewBase SetTable", tableParams, layout);
                    table.setLayoutByName(this._finderOptions.presetTableLayout);
                }
            }

            this.UiModder.domConstruct.place(table.domNode, this.resultContainer);

            table.on("layoutChange", lang.hitch(this, this._onTableLayoutChanged));

            this.table = table;
            this.emit("tableAssigned", table);
        }

        if (this._completeList) {


            table.setData(this._completeList, this.setupConfig.keyValueAttribute, this.setupConfig.labelProperty, response.totalResultCount, response.startIndex);
            let scrollTargetRow: StaticTable.StaticTableRow<any> = null;

            if (this.scrollTargetIndex) {

                let group = table.getRowGroup(this.scrollTargetIndex);

                console.debug("get row from scroll-target", this.scrollTargetIndex, group);

                if (group) {
                    if (group.rows.length) {
                        scrollTargetRow = group.rows[0];
                    }
                }
            }

            if (scrollTargetRow) {
                this.displayDataSection(scrollTargetRow.node);
            }
            else {
                //this.displayDataSection();
            }

        }

        if (this.resultContainer) this.UiModder.domClass.remove(this.resultContainer, "w3-hide");

        table.setCyName("table:" + this.internalName);
        this.UiModder.domAttr.set(table.domNode, "data-table-type", (<any>this).declaredClass);

        // internalName ist erst nach dem Config-/Result-Load gesetzt; in postCreate (domNode)
        // und finderSetup (Reload-Button) war es noch null -> "finder:null"/"Button:null:Reload".
        // Hier nachziehen, damit alle data-cy konsistent den internalName tragen.
        this.domNode.setAttribute("data-cy", "finder:" + this.internalName);
        (this.btnReloadPage as any)?.setCyName?.("Button:" + this.internalName + ":Reload");

        this.emit("tableReady", table);
        return table;
    }
    // Static TABLE -----------------------------------------END
    private scrollTargetIndex: any = null;

    private displayDataSection(targetNode?: HTMLElement/*, style: "start" | "end" | "nearest" = "nearest", highlightClass?: string, removeTimeout?: number*/) {
        this.UiModder.domClass.remove(this.resultContainer, "w3-hide");

        let bHighlight = false;
        if (!targetNode) {
            targetNode = this.resultContainer;
        } else {
            bHighlight = true;
        }

        targetNode.scrollIntoView({
            behavior: "smooth",
            block: bHighlight ? "end" : "nearest"//style,
        });

        if (bHighlight == true) {
            let highlightClass = "highlight";
            this.UiModder.domClass.add(targetNode, highlightClass);
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, targetNode, highlightClass), 5000);
        }
    }

    //response:  {layoutname: bla, metadata:bla,  entitylistPropertyname: [...entities]}
    protected processFilterListResponse(responseUnknown: more.PackedEntitylistResult<any> | Array<any>) {

        //console.log("Filterdata response: ", response, this.getDirty(), this._completeList)
        this.scrollTargetIndex = null;
        let response: more.PackedEntitylistResult<any> = null;

        let responseAsArray = responseUnknown as Array<any>;
        if (typeof (responseAsArray?.length) == "number" && responseAsArray.indexOf) {
            let newResponse: more.PackedEntitylistResult<any> = {
                entitylist: responseAsArray,
                startIndex: this._getOffsetFromPage(this._currentPage),
                totalResultCount: responseAsArray.length,
            };

            this.lastResponse = newResponse;

            this.isPagingEnabled = false;

            this.setupConfig.entityListProperty = "entitylist";
            response = newResponse;
        }
        else {
            response = responseUnknown as any;
        }

        if (this.setupConfig.entityListProperty && response[this.setupConfig.entityListProperty]) {

            if (this.getDirty() === true) {
                this._completeList = [];
            }

            //this._completeList_lastResponse_FirstEntityIndex = this._completeList.length? this._completeList.length-1 : 0

            for (let entity of response[this.setupConfig.entityListProperty]) {

                let tableEntity = entity;

                if (this._completeList.length) {
                    let index: number = -1;
                    for (let i = 0; i < this._completeList.length; i++) {
                        let entry = this._completeList[i];
                        let value = entry[this.setupConfig.keyValueAttribute];
                        let compareValue = tableEntity[this.setupConfig.keyValueAttribute];
                        if (value == compareValue && value && compareValue) {
                            index = i;
                            break;
                        }
                    }
                    if (index == -1) {
                        this._completeList.push(tableEntity);
                        if (this.scrollTargetIndex == null) {
                            this.scrollTargetIndex = this._completeList.length - 1;
                        }
                    } else {
                        this._completeList[index] = tableEntity;
                    }
                } else {
                    this._completeList.push(tableEntity);
                    this.scrollTargetIndex = 0;
                }
            }


            let table = this.createTable(response);

            //this._completeList_lastResponse_LastEntityIndex = this._completeList.length ? this._completeList.length - 1 : 0;
            if (this.onFilterListResponse) {
                this.onFilterListResponse();
            }


        } else {
            alert(this.id + ": response does not contain known entitylist-property!");
            console.error(this.id + ": response does not contain known entitylist-property!", response);
        }
    }



    private setSubmitButtonStyles(): void {

        let endOfList: boolean = false;
        endOfList = this._currentPage >= this._getMaxPagesFromResult();

        if (this.btnSubmit) {

            let bEnabled = false;


            if (this.getDirty() == true && this._isRequestActive != true) {
                //console.debug("setSubmitButtonStyle ENABLED", this.classesEnabled, endOfList, this.getDirty(), this._isRequestActive);
                bEnabled = true;
            }
            this.disableNode(this.btnSubmit, !bEnabled);

        }


        if (this.btnLastPage) {
            let bEnabled = false;

            if (!endOfList && this._isRequestActive != true && this.isPagingEnabled) {
                bEnabled = true;
            }

            this.disableNode(this.btnLastPage, !bEnabled);
        }

        if (this.btnNextPage) {
            let bEnabled = false;


            if (!endOfList && this._isRequestActive != true && this.isPagingEnabled) {
                bEnabled = true;
            }
            this.disableNode(this.btnNextPage, !bEnabled);
        }

        if (this.btnPreviousPage) {
            let bEnabled = false;

            if (this._currentPage > 1 && this._isRequestActive != true && this.isPagingEnabled) {
                bEnabled = true;
            }

            this.disableNode(this.btnPreviousPage, !bEnabled);
        }

        if (this.btnFirstPage) {
            let bEnabled = false;

            if (this._currentPage > 1 && this._isRequestActive != true && this.isPagingEnabled) {
                bEnabled = true;
            }
            this.disableNode(this.btnFirstPage, !bEnabled);
        }
    }

    private _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || !this.isDirty) {
            return;
        }

        this.getFilterlist(1);
    }

    private _onClick_Continue(evt: MouseEvent) {
        if (this._isRequestActive === true) return;

        if (this._currentPage < this._getMaxPagesFromResult()) {
            this.setPage(this._currentPage + 1, true);
        }
    }

    private _onClick_PreviousPage(evt: MouseEvent) {
        if (this.isPagingEnabled && this._currentPage > 1) {
            this.setPage(this._currentPage - 1, true);
        }
    }
    private _onClick_NextPage(evt: MouseEvent) {
        if (this.isPagingEnabled && this._currentPage < this._getMaxPagesFromResult()) {
            this.setPage(this._currentPage + 1, true);
        }
    }

    private _onClick_FirstPage(evt: MouseEvent) {
        this.setPage(1, true);
    }

    private _onClick_LastPage(evt: MouseEvent) {
        this.setPage(this._getMaxPagesFromResult(), true);
    }

    private _onClick_Reload(evt: MouseEvent) {
        this.reload();
    }

    /**
     * Die aktuelle Seite intern setzen (beginnend mit 1 !!), optional Sucheregebnisse laden und richtiges Umschalten auslösen.
     * @param page
     * @param loadResults
     */
    setPage(page: number = 1, loadResults?: boolean) {
        if (!page || page < 1) {
            page = 1;
        }
        if (this.isPagingEnabled) {
            let currentButton = document.getElementById("pageBtn-" + this._currentPage.toString());
            if (currentButton) this.UiModder.domClass.remove(currentButton, "selected hoverDark hoverBright");

            let secondButton = document.getElementById("pageBtnSecond-" + this._currentPage.toString());
            if (secondButton) this.UiModder.domClass.remove(secondButton, "selected hoverDark hoverBright");

            if (this._currentPage != page) {
                this._completeList = [];
            }
            this._currentPage = page;

            currentButton = document.getElementById("pageBtn-" + this._currentPage.toString());
            if (currentButton) this.UiModder.domClass.add(currentButton, "selected hoverBright");

            secondButton = document.getElementById("pageBtnSecond-" + this._currentPage.toString());
            if (secondButton) this.UiModder.domClass.add(secondButton, "selected hoverBright");
        } else {
            this._currentPage = page;
        }

        if (loadResults === true) {
            this.getFilterlist();
        }
    }

    protected _getOffsetFromPage(pageNo: number): number {
        if (!pageNo || pageNo <= 1 || !this.isPagingEnabled) {
            return 0;
        }

        return this._maxResultCount * pageNo - this._maxResultCount;
    }

    private _getPageFromIndex(index: number, totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!totalResultCount || totalResultCount == 0) return 0;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return 1;
        }

        let counter = 1;
        let currentIndex = 0;
        while (currentIndex + this._maxResultCount < index) { // zb 0 + 30 = 30, index = 34
            index = index + this._maxResultCount;
            counter++;
        }

        return counter;
    }

    private _getMaxIndexOfPage(pageNo: number, totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!pageNo) {
            pageNo = this._currentPage;
        }

        if (!totalResultCount || totalResultCount == 0 || pageNo < 1) return 0;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return totalResultCount - 1;
        }

        let maxPage = this._getMaxPagesFromResult(totalResultCount);
        if (pageNo >= maxPage) {
            return totalResultCount - 1;
        }

        return pageNo * this._maxResultCount - 1;
    }

    private _getMinIndexOfPage(pageNo: number, totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!pageNo) {
            pageNo = this._currentPage;
        }

        if (!totalResultCount || totalResultCount == 0) return -1;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return 0;
        } else if (pageNo <= 1) {
            return 0;
        }


        let maxPage = this._getMaxPagesFromResult(totalResultCount);
        if (pageNo > maxPage) {
            return totalResultCount;
        }

        return pageNo * this._maxResultCount - this._maxResultCount;
    }

    private _getMaxPagesFromResult(totalResultCount?: number): number {
        if (!totalResultCount && this.lastResponse) {
            totalResultCount = this.lastResponse.totalResultCount;
        }

        if (!totalResultCount || totalResultCount == 0) return 0;

        if (!this.isPagingEnabled || this._maxResultCount < 1) {
            return 1;
        }

        let counter = 1;
        let index = 0;
        while (index + this._maxResultCount < totalResultCount) {
            index = index + this._maxResultCount;
            counter++;
        }

        return counter;
    }

    ///// ----------------- overloads -----------------------------------END
    /////-------------------getters && setters --------------------------START

    private _initialLoadDone: boolean = false;

    setDirty(value?: boolean): void {

        let oldValue = this.isDirty;

        this.isDirty = value === true;

        if (this.isDirty === true) {
            //this._nextStartIndex = 0;
            if (this.sectionResult && this.filterpanel) {
                this.UiModder.domClass.add(this.sectionResult, "w3-disabled");
                this._currentPage = 1;
                //this.setPage(0);
            }
            if (!this.filterpanel) {
                this.setPage(0, true);
            } else if (this._finderOptions?.initialLoad === true && !this._initialLoadDone) {
                this._initialLoadDone = true;
                this.setPage(0, true);
            }
        } else {
            if (this.sectionResult) {
                this.UiModder.domClass.remove(this.sectionResult, "w3-disabled");
            }
        }

        this.setSubmitButtonStyles();

        // HOTFIX: das emit stört wenns im Tab daherkommt, weil das ja keine "ungespeicherte Änderung" ist...
    //    if (!this.isEmbeddedInTab) {
    //        if (oldValue != this.isDirty) {
    //            this.emit("dirty", this.isDirty);
    //        }
    //    }

        // eigentlich kanns gar nie sinnvoll sein, dass ein Finder sich "dirty" meldet
        // nur das Filterpanel soll sich BEIM FINDER dirty melden. der Finder ist in sich gekapselt und muss keinem was melden

        // für mich selber stattdessen ein Event machen, das aufgerufen wird:
        if (oldValue != this.isDirty) {
            if (this.onDirtyChange) {
                this.onDirtyChange(this.isDirty);
            }
        }
    }

    protected onDirtyChange(isDirty: boolean) {
        // in Kindklasse programmieren bei Bedarf...
    }

    protected _onTableCreated(table: MdsLax<InstanceType<typeof StaticTable>>) {
        table.on("tableDrawn", lang.hitch(this, this._onTableDrawn, table));
        table.on("beforeTableDrawn", lang.hitch(this, this._beforeTableDrawn, table));
    }

    protected _beforeTableDrawn(table: MdsLax<InstanceType<typeof StaticTable>>) {

    }

    protected _onTableDrawn(table: MdsLax<InstanceType<typeof StaticTable>>) {

    }

    private _setDirtyAttr(value?: boolean) {
        this.setDirty(value);
    }
    getDirty(): boolean {
        return this.isDirty;
    }
    private _getDirtyAttr(): boolean {
        return this.getDirty();
    }

    protected setResultlistPropertyName(name: string) {
        this.setEntitylistPropertyName(name);
    }

    protected setEntitylistPropertyName(name: string) {
        this.setupConfig.entityListProperty = name;
    }

    private requestParams: Array<{ name: string, value: any }> = null;
    private requestData: Object = null;

    finderSetup(config: FinderTypes.FinderSetupConfig) {

        if (!config) return;

        if (!config.keyValueAttribute) config.keyValueAttribute = "ID";
        if (!config.entityListProperty) config.entityListProperty = "entitylist";

        this._checkPagingEnabled();

        if (this.btnReloadPage) {
            on(this.btnReloadPage, "click", lang.hitch(this, this._onClick_Reload));
            (this.btnReloadPage as any).setCyName?.("Button:" + this.internalName + ":Reload");
        }

        this.setupConfig = config;

        this.requestParams = [];
        if (this.setupConfig.additionalRequestData && this.setupConfig.additionalRequestData.length) {
            this.requestData = {};
            for (let param of this.setupConfig.additionalRequestData) {
                if (param.setAsNewParameter === true) {
                    this.requestParams.push({ name: param.name, value: param.value });
                } else {
                    this.requestData[param.name] = param.value;
                }
            }
        }

        if (this.setupConfig.tableLayouts) {
            let layoutAsArray = this.setupConfig.tableLayouts as StaticTable.Layout[];
            if (layoutAsArray.length) {
                this._tableLayouts = layoutAsArray;
            } else {
                let layoutSingle = this.setupConfig.tableLayouts as any;
                this._tableLayouts = [layoutSingle];
            }
        }

        this.loadFinderConfig();
        if (this.setupConfig.newEntryParams && this.setupConfig.newEntryParams.callback) {
            if (this.setupConfig.newEntryParams.neededUserRole) {
                this.hasUserRole(this.setupConfig.newEntryParams.neededUserRole, lang.hitch(this, this._displayNewButton, this.setupConfig.newEntryParams.callback));
            } else {
                this._displayNewButton(this.setupConfig.newEntryParams.callback, true);
            }
        } else {
            this._displayNewButton(null, false);
        }

    }

    /**
     * Den Finder konfigurieren und starten.
     * @param configCallfunction Callfunction zum Abrufen der Konfiguration mit Fiilterpanel und Tabellenlayouts
     * @param filterdataCallfunction Callfunction zum Laden der Ergebnisse
     * @param rowClickFunction Optional: Callback bei Klick auf einen Eintrag in der Tabelle
     * @param tableFormatterFunction Optional: Formatierungsfunktion für Tabellenzellen
     * @param newEntryParams Objekt mit einer benötigten, zu prüfenden Userrolle (oder leer wenn immer möglich) und Callback für den Neu-Button
     * @param additionalRequestData Zusätzliche Parameter im Request (wird zu jsonData eingefügt, oder als separater Wert wenn setAsNewParameter true)
     */
    setupFinderWithCallfunctions(configCallfunction: string,
        filterdataCallfunction: string,
        rowClickFunction: StaticTable.rowclickCallback,
        tableFormatterFunction: StaticTable.formatterCallback,
        newEntryParams?: { neededUserRole: string | Array<string>, callback: Function, label?: string, groupName?: string },
        additionalRequestData?: Array<{ name: string, value: any, setAsNewParameter?: boolean }>,
        tableRowExpanderConfig?: FinderTypes.TableRowExpanderConfig): void {


        this.finderSetup({
            configUrl: null,
            filterdataUrl: null,
            rowClickFunction: rowClickFunction,
            configCallfunction: configCallfunction,
            filterdataCallfunction: filterdataCallfunction,
            additionalRequestData: additionalRequestData,
            tableRowExpanderConfig: tableRowExpanderConfig,
            newEntryParams: newEntryParams,
            tableFormatterFunction: tableFormatterFunction
        });
    }

    /**
     * Den Finder konfigurieren und starten.
     * @param configUrl URL zum Abrufen der Konfiguration mit Fiilterpanel und Tabellenlayouts
     * @param filterdataUrl URL zum Laden der Ergebnisse
     * @param rowClickFunction Optional: Callback bei Klick auf einen Eintrag in der Tabelle
     * @param tableFormatterFunction Optional: Formatierungsfunktion für Tabellenzellen
     * @param newEntryParams Objekt mit einer benötigten, zu prüfenden Userrolle (oder leer wenn immer möglich) und Callback für den Neu-Button
     * @param additionalRequestData Zusätzliche Parameter im Request (wird zu jsonData eingefügt, oder als separater Wert wenn setAsNewParameter true)
     */
    setupFinder(configUrl: string,
        filterdataUrl: string,
        rowClickFunction: StaticTable.rowclickCallback,
        tableFormatterFunction: StaticTable.formatterCallback,
        newEntryParams?: { neededUserRole: string | Array<string>, callback: Function, label?: string, groupName?: string },
        additionalRequestData?: Array<{ name: string, value: any, setAsNewParameter?: boolean }>,
        tableRowExpanderConfig?: FinderTypes.TableRowExpanderConfig): void {

        this.finderSetup({
            configUrl: configUrl,
            filterdataUrl: filterdataUrl,
            rowClickFunction: rowClickFunction,
            configCallfunction: null,
            filterdataCallfunction: null,
            additionalRequestData: additionalRequestData,
            tableRowExpanderConfig: tableRowExpanderConfig,
            newEntryParams: newEntryParams,
            tableFormatterFunction: tableFormatterFunction
        });
    }

    /////-------------------getters && setters --------------------------END

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._tableLayouts = [];

        //default stuff
        //if (!this.classesEnabled) this.classesEnabled = "accentBG hoverBright";
        //if (!this.classesDisabled) this.classesDisabled = "w3-disabled tertiaryBG";
        if (!this.btnSubmitLabelText) this.btnSubmitLabelText = "Search"; // to be replaced with translation in a childclass
        const name = this.filterpanel?.name?.trim();
        const id = `${name ? name + ":" : ""}buttonSearch`;
        this._setCyAttribute("ButtonSearch:" + this.btnSubmitLabelText, this.btnSubmit);
        this.domNode.setAttribute("data-cy", "finder:" + this.internalName);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }

    _setCyAttribute(label: string, element: HTMLElement | null): void {
        if (!element) {
            return;
        }

        const dataCy = [
            this.internalName,
            label
        ]
            .map(value => typeof value === "string" ? value.trim() : "")
            .filter(value => value !== "")
            .join(":");

        element.setAttribute("data-cy", dataCy);
    }
}

export default mdsWidget(FinderBaseV2);
